import type { HttpProblem } from '../api/generated/client';

type Listener = (p: HttpProblem | null) => void;

class BannerService {
    private readonly listeners: Set<Listener> = new Set();
    private current: HttpProblem | null = null;

    subscribe(fn: Listener) {
        this.listeners.add(fn);
        fn(this.current);

        return () => {
            this.listeners.delete(fn);
        };
    }

    show(problem: HttpProblem) {
        this.current = problem;
        for (const listener of this.listeners) listener(problem);
    }

    clear() {
        this.current = null;
        for (const listener of this.listeners) listener(null);
    }
}

export const bannerService = new BannerService();
